import React from 'react'
import { withTranslation } from 'react-i18next'

function Field({ label, hint, children }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-dark-blue">{label}</label>
      {children}
      {hint && <p className="text-xs text-secondary">{hint}</p>}
    </div>
  )
}

export default withTranslation()(function BasicDetailsStep({ t, form, updateField }) {
  return (
    <div className="flex flex-col gap-6 max-w-[640px]">
      <h2 className="text-xl font-semibold text-dark-blue">{t('rewardAds.createFlow.basic.title')}</h2>

      <Field label={t('rewardAds.createFlow.basic.fields.title.label')} hint={t('rewardAds.createFlow.basic.fields.title.hint')}>
        <input
          type="text"
          value={form.title}
          onChange={(event) => updateField('title', event.target.value)}
          placeholder={t('rewardAds.createFlow.basic.fields.title.placeholder')}
          className="w-full border border-border-lines rounded-lg px-3 py-2.5 text-sm text-dark-blue outline-none"
        />
      </Field>

      <Field label={t('rewardAds.createFlow.basic.fields.callback_url.label')} hint={t('rewardAds.createFlow.basic.fields.callback_url.hint')}>
        <input
          type="url"
          value={form.callbackUrl}
          onChange={(event) => updateField('callbackUrl', event.target.value)}
          placeholder={t('rewardAds.createFlow.basic.fields.callback_url.placeholder')}
          className="w-full border border-border-lines rounded-lg px-3 py-2.5 text-sm text-dark-blue outline-none"
        />
      </Field>

      <Field label={t('rewardAds.createFlow.basic.fields.cta_message.label')} hint={t('rewardAds.createFlow.basic.fields.cta_message.hint')}>
        <input
          type="text"
          value={form.ctaMessage}
          onChange={(event) => updateField('ctaMessage', event.target.value)}
          placeholder={t('rewardAds.createFlow.basic.fields.cta_message.placeholder')}
          className="w-full border border-border-lines rounded-lg px-3 py-2.5 text-sm text-dark-blue outline-none"
        />
      </Field>

      <Field label={t('rewardAds.createFlow.basic.fields.description.label')} hint={t('rewardAds.createFlow.basic.fields.description.hint')}>
        <textarea
          rows={4}
          value={form.description}
          onChange={(event) => updateField('description', event.target.value)}
          placeholder={t('rewardAds.createFlow.basic.fields.description.placeholder')}
          className="w-full border border-border-lines rounded-lg px-3 py-2.5 text-sm text-dark-blue outline-none resize-none"
        />
      </Field>
    </div>
  )
})
